import React, { createContext, useContext, useState, useEffect } from 'react';
import { isPrimaryFollowrHostname } from 'components/ui/utils/constant';

const WhitelabelDetectionContext = createContext();

export const useWhitelabelDetection = () => {
  const context = useContext(WhitelabelDetectionContext);
  if (!context) {
    throw new Error('useWhitelabelDetection must be used within a WhitelabelDetectionProvider');
  }
  return context;
};

export const WhitelabelDetectionProvider = ({ children }) => {
  const _initMustBeWhitelabeled = !isPrimaryFollowrHostname(window.location.hostname) || window.location.search.includes('wl=');
  const [mustBeWhitelabeled, setMustBeWhitelabeled] = useState(_initMustBeWhitelabeled);
  const [whitelabelUserId, setWhitelabelUserId] = useState(null);

  useEffect(() => {
    const checkWhitelabelRequirement = () => {
      const isWhitelabelRequired = !isPrimaryFollowrHostname(window.location.hostname) || window.location.search.includes('wl=');
      setMustBeWhitelabeled(isWhitelabelRequired);
    };

    checkWhitelabelRequirement();

    // Listen for URL changes (for SPA navigation)
    const handlePopState = () => {
      checkWhitelabelRequirement();
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);
  
  // useEffect(() => {
  //   if (mustBeWhitelabeled) {
  //     window?.Intercom('update', {
  //       "hide_default_launcher": true
  //     });
  //   } else {
  //     window?.Intercom('update', {
  //       "hide_default_launcher": false
  //     });
  //   }
  // }, [mustBeWhitelabeled]);

  return (
    <WhitelabelDetectionContext.Provider value={{ 
      mustBeWhitelabeled,
      whitelabelUserId,
      setWhitelabelUserId
    }}>
      {children}
    </WhitelabelDetectionContext.Provider>
  );
}; 